module.exports = __webpack_public_path__ + "img/success.ecfa6ba8.svg";